
import * as ipxRuntime$JkrzXMyPMp_45uMK8HTEpGYCWEx5FjrkM5qKNTsgSA_45Nc from '/opt/buildhome/repo/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as noneRuntime$xE9KMRiGqn3yo2hrxf9qfO2f6nr61klikzRA3Fur7gU from '/opt/buildhome/repo/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "listing": {
      "modifiers": {
        "height": 227,
        "fit": "fill",
        "format": "webp"
      }
    }
  },
  "provider": "none",
  "domains": [
    "bio-circle-backend.go2flow.dev",
    "cp.bio-circle.ch"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$JkrzXMyPMp_45uMK8HTEpGYCWEx5FjrkM5qKNTsgSA_45Nc, defaults: {} },
  ['none']: { provider: noneRuntime$xE9KMRiGqn3yo2hrxf9qfO2f6nr61klikzRA3Fur7gU, defaults: {} }
}
        